import { findSlotsForTimeFrame, isSlotStartingHour } from 'utils/booking';
import { BookingSlot } from 'api-types/models/Booking';
import { BookingSlotContent } from '../bookingSlotContent';

interface IProps {
    hour: number;
    startOfWeekDate: Date;
    index: number;
    slotsPerWeek: BookingSlot[];
    setSelectedSlot: (slot: BookingSlot) => void;
}

export function BookingTableCell({
    hour,
    startOfWeekDate,
    index,
    slotsPerWeek,
    setSelectedSlot
}: Readonly<IProps>) {
    const slots = findSlotsForTimeFrame(
        startOfWeekDate,
        index,
        hour,
        slotsPerWeek
    );

    // Only render slots that START in this hour
    const slotsToRender = slots
        .filter((slot) =>
            isSlotStartingHour(startOfWeekDate, index, hour, slot)
        )
        .sort((a, b) => a.from - b.from);

    const parallelCount = slotsToRender.length;

    return (
        <td className={slotsToRender.length > 0 ? 'active' : 'empty'}>
            <div className='wrapper'>
                {slotsToRender.map((slot, parallelIndex) => (
                    <BookingSlotContent
                        key={slot.slotId}
                        slot={slot}
                        setSelectedSlot={setSelectedSlot}
                        slotStartHour={hour}
                        parallelIndex={parallelIndex}
                        parallelCount={parallelCount}
                    />
                ))}
            </div>
        </td>
    );
}
